import React from "react"
import styles from './Title.module.scss';

export const FormTitle: React.FC = () => {
  return (
    <div id="form-title" className={styles.Title}>
      <h1 className={styles.title}>
        Nos informe seus dados
      </h1>
      <h2 className={styles.subTitle}>
        Em breve entraremos em contato
      </h2>
    </div>
  )
}